import { toast } from "react-toastify";
import { postLogin, tickets } from "../../helpers/backend_helper";
import {
  ASSIGN_TICKET_FAILURE,
  ASSIGN_TICKET_SUCCESS,
  CHANGE_LAYOUT,
  CHANGE_LAYOUT_MODE,
  CHANGE_LAYOUT_WIDTH,
  CHANGE_SIDEBAR_THEME,
  CHANGE_SIDEBAR_TYPE,
  CHANGE_TOPBAR_THEME,
  CREATE_TICKETS_FAILURE,
  CREATE_TICKETS_SUCCESS,
  FETCH_TICKET_BY_ID_FAILURE,
  FETCH_TICKET_BY_ID_SUCCESS,
  FETCH_TICKETS_FAILURE,
  FETCH_TICKETS_SUCCESS,
  FETCH_USERS_FAILURE,
  FETCH_USERS_SUCCESS,
  SHOW_RIGHT_SIDEBAR,
  SHOW_SIDEBAR,
  TOGGLE_LEFTMENU,
  UPDATE_TICKET_STATUS_FAILURE,
  UPDATE_TICKET_STATUS_SUCCESS,
  UPDATE_TICKETS_FAILURE,
  UPDATE_TICKETS_SUCCESS,
} from "./actionTypes";
import { fetchDashboardDetails } from "../dashboard/actions";

export const changeLayout = (layout) => ({
  type: CHANGE_LAYOUT,
  payload: layout,
});

export const changeLayoutMode = (layoutMode) => ({
  type: CHANGE_LAYOUT_MODE,
  payload: layoutMode,
});

export const changeLayoutWidth = (width) => ({
  type: CHANGE_LAYOUT_WIDTH,
  payload: width,
});

export const changeSidebarTheme = (theme) => ({
  type: CHANGE_SIDEBAR_THEME,
  payload: theme,
});

export const changeSidebarType = (sidebarType, isMobile) => {
  return {
    type: CHANGE_SIDEBAR_TYPE,
    payload: { sidebarType, isMobile },
  };
};

export const changeTopbarTheme = (topbarTheme) => ({
  type: CHANGE_TOPBAR_THEME,
  payload: topbarTheme,
});

export const showRightSidebarAction = (isopen) => ({
  type: SHOW_RIGHT_SIDEBAR,
  payload: isopen,
});

export const showSidebar = (isopen) => ({
  type: SHOW_SIDEBAR,
  payload: isopen,
});

export const toggleLeftmenu = (isopen) => ({
  type: TOGGLE_LEFTMENU,
  payload: isopen,
});

// export const fetchTickets = (payload) => ({
//   type: VIEW_TICKETS,
//   payload,
// });

export const fetchTickets = (filters = {}) => async (dispatch) => {
  // Fetch all pages from the tickets API until we've retrieved all tickets
  const pageLimit = filters.limit || 500; // default limit per page
  let page = filters.page || 1;
  const allTickets = [];
  let lastPagination = {};

  try {
    while (true) {
      const payload = {
        act: "ticket",
        subact: "view",
        filter: {
          displayStatus: filters.displayStatus || "",
          search: filters.search || "",
          assignedToFirstName: filters.guard || "",
        },
        paggination: {
          limit: pageLimit,
          page,
        },
      };

      const response = await tickets(payload);

      const pageTickets = response?.data?.ticket || [];
      const pagination = response?.data?.pagination || {};

      // Append page results
      allTickets.push(...pageTickets);
      lastPagination = pagination;

      // If pagination info present, check if there are more pages
      // Assume pagination has 'page' and 'totalPages' or 'total' and 'limit'
      const currentPage = pagination.page || page;
      const totalPages = pagination.totalPages || (pagination.total && pagination.limit ? Math.ceil(pagination.total / pagination.limit) : null);

      if (totalPages && currentPage < totalPages) {
        page = currentPage + 1;
        continue;
      }

      // If response returned fewer items than requested, we've likely reached the end
      if ((!totalPages && pageTickets.length < pageLimit) || (totalPages && currentPage >= totalPages)) {
        break;
      }

      // Fallback: increment page and try again (defensive)
      page += 1;
    }

    // Dispatch combined ticket list
    dispatch({
      type: FETCH_TICKETS_SUCCESS,
      payload: {
        tickets: allTickets,
        pagination: lastPagination || {},
      },
    });
  } catch (error) {
    dispatch({
      type: FETCH_TICKETS_FAILURE,
      error: "Failed to fetch tickets. Please try again.",
    });
  }
};

export const fetchUsers = (inputValue,role) => async (dispatch) => {
  const payload = {
    act: "user",
    subact: "searchUsers",
    info: {
      role:role
    },
    filter: { search: inputValue },
  };

  try {
    const response = await postLogin(payload);
    if (response.data) {
      dispatch({
        type: FETCH_USERS_SUCCESS,
        payload: {
          users: response.data,
        },
      });
    } else {
      dispatch({
        type: FETCH_USERS_FAILURE,
        error: "No users found.",
      });
    }
  } catch (error) {
    dispatch({
      type: FETCH_USERS_FAILURE,
      error: "Failed to fetch users. Please try again.",
    });
  }
};

export const getTicketById =
  (ticketId, navigate, editable) => async (dispatch) => {
    const payload = {
      act: "ticket",
      subact: "get",
      info: { ticketId },
    };

    try {
      const response = await tickets(payload);

      if (response.data) {
        dispatch({
          type: FETCH_TICKET_BY_ID_SUCCESS,
          payload: response.data,
        });

        navigate(`/update-ticket?id=${ticketId}`, {
          state: { ticketData: response.data, editable },
        });
      } else {
        dispatch({
          type: FETCH_TICKET_BY_ID_FAILURE,
          error: "No ticket found.",
        });
      }
    } catch (error) {
      dispatch({
        type: FETCH_TICKET_BY_ID_FAILURE,
        error: "Failed to fetch ticket. Please try again.",
      });
    }
  };
export const createTicket = (data, navigate) => async (dispatch) => {
  try {
    // Extract incident location if present
    const [lat, lon] = data.incidentLocation?.split(",").map(Number) || [
      null,
      null,
    ];

    // Create payload with structured location data
    const payload = {
      act: "ticket",
      subact: "create",
      info: {
        ...data,
        incidentLocation: {
          lat,
          long: lon,
        },
      },
    };

    // Remove the raw incident location field
    // delete payload.info.incidentLocation;

    const response = await tickets(payload);

    if (response.message.includes("success")) {
      
      toast.success(response?.message, {
        position: "top-right",
        autoClose: 3000,
      });
      fetchDashboardDetails()
      fetchTickets({ status: "", search: "", limit: 50 });
      // navigate("/manage-ticket");
    } else {
      dispatch({
        type: CREATE_TICKETS_FAILURE,
        error: response.message,
      });
    }
  } catch (error) {
    dispatch({
      type: CREATE_TICKETS_FAILURE,
      error: "No matching region found for the given coordinates",
    });
  }
};

export const updateTicket = (data, navigate) => async (dispatch) => {
  const payload = {
    act: "ticket",
    subact: "update",
    info: data,
  };

  try {
    const response = await tickets(payload);
    if (response.message.includes("success")) {
      dispatch({
        type: UPDATE_TICKETS_SUCCESS,
        payload: response.data,
      });
      toast.success(response?.message, {
        position: "top-right",
        autoClose: 3000,
      });

      navigate("/manage-ticket");
    } else {
      dispatch({
        type: UPDATE_TICKETS_FAILURE,
        error: "Error while updating a ticket.",
      });
    }
  } catch (error) {
    dispatch({
      type: UPDATE_TICKETS_FAILURE,
      error: "Failed to update ticket. Please try again.",
    });
  }
};

export const updateTicketStatus = (data) => async (dispatch) => {
  try {
    const response = await tickets(data);
    if (response.message.includes("success")) {
      dispatch({
        type: UPDATE_TICKET_STATUS_SUCCESS,
        payload: response.data,
      });
      return { message: response.message }; // Ensure the return object
    } else {
      dispatch({
        type: UPDATE_TICKET_STATUS_FAILURE,
        error: "Error while updating ticket status.",
      });
      return { message: response.message }; // Ensure the return object
    }
  } catch (error) {
    dispatch({
      type: UPDATE_TICKET_STATUS_FAILURE,
      error: "Failed to update ticket status. Please try again.",
    });
    return { message: "Failed to update ticket status. Please try again." }; // Ensure the return object
  }
};

export const assignUserToTicketId = (data) => async (dispatch) => {
  try {
    const response = await tickets(data);
    if (response.message.includes("success")) {
      dispatch({
        type: ASSIGN_TICKET_SUCCESS,
        payload: response.data,
      });
      return { message: response.message }; // Ensure the return object
    } else {
      dispatch({
        type: ASSIGN_TICKET_FAILURE,
        error: "Error while assigning ticket.",
      });
      return { message: response.message }; // Ensure the return object
    }
  } catch (error) {
    dispatch({
      type: ASSIGN_TICKET_FAILURE,
      error: "Failed to assign ticket. Please try again.",
    });
    return { message: "Failed to assign ticket. Please try again." }; // Ensure the return object
  }
};
